<div *ngIf="newContact" class="ta-center">
  <span class="bold-text-color">{{ 'CRM_DETAIL.NewContact' | translate }}</span>
</div>
<div *ngIf="!dataForSelectReady" class="my-40">
  <mat-spinner class="m-0-auto" diameter="40"></mat-spinner>
</div>
<div *ngIf="dataForSelectReady">

</div>
